/* eslint-disable import/no-named-default */
import { LitElement } from "lit";

import { Constructor } from "@slhuicore/base";
import {
  Translatable as SlhCoreTranslatable,
  SlhCoreTranslatableInterface,
  Translations,
  LOCALE_ENGLISH,
  LOCALE_GERMAN,
} from "@slhuicore/i18n";

import { default as en } from "../assets/en.json";
import { default as de } from "../assets/de.json";

const Translatable = <T extends Constructor<LitElement>>(superClass: T) => {
  class TranslatableElement extends SlhCoreTranslatable(superClass) {
    // eslint-disable-next-line class-methods-use-this
    public getDefaultTranslationSources(): Map<string, Translations> | void {
      const defaultTranslations = new Map();
      defaultTranslations.set(LOCALE_ENGLISH, en);
      defaultTranslations.set(LOCALE_GERMAN, de);

      return defaultTranslations;
    }
  }

  return TranslatableElement as Constructor<SlhCoreTranslatableInterface> & T;
};

// eslint-disable-next-line import/prefer-default-export
export { Translatable };
